<app-modal [modalId]="modalId">
  @if (isLoading) {
    <div class="loader-container">
      <app-spinner></app-spinner>
    </div>
  }
  @if (!isLoading) {
    <div>
      <app-offer-modals-header
        heading="{{CONSTANTS.labelTitle}}"
        [tenantName]="tenantName">
      </app-offer-modals-header>
      @if (removalHistory) {
        <div class="posting-section"  tabindex="0">
          @for (entity of removalHistory; track entity; let even = $even; let i = $index) {
            <div class="posting-section__date">
              <span [id]="'posting_history_transaction_date_' + i" class="posting-section__date-text">{{localizeDate(entity.statusChangedDate)}}</span>
            </div>
            <div class="posting-section--details" [ngClass]="even  ? 'row-even' : 'row-odd'">
              <p class="removal-time">
                {{formatTime(entity)}}
              </p>
              <p>
                <span class="bold">{{CONSTANTS.labelRemovalReason}}</span>
                <br class="mobile-break">
                {{entity.removalReason}}
              </p>
              <p>
                <span class="bold">{{CONSTANTS.labelPostedDate}}</span>
                <br class="mobile-break">
                {{formatDateTime(entity)}}
              </p>
              <div class="extra-space"></div>
              <p>
                <span class="bold">{{CONSTANTS.labelHits}}</span>
                <br class="mobile-break">
                {{entity.viewCount}}
              </p>
              <p>
                <span class="bold">{{CONSTANTS.labelBidListAdds}}</span>
                <br class="mobile-break">
                {{entity.bidListAdds}}
              </p>
              <p>
                <span class="bold">{{CONSTANTS.labelPostingPrice}}</span>
                <br class="mobile-break">
                {{entity.currentAmount ? formatCurrency(entity.currentAmount) : 'N/A'}}
              </p>
              <div class="history-col">
                <p>
                  <span class="bold">{{CONSTANTS.labelBuyNowPrice}} </span>
                  <br class="mobile-break">
                  {{entity.buyNowAmount ?  formatCurrency(entity.buyNowAmount) : 'N/A'}}
                </p>
                <p>
                  <span class="bold">{{CONSTANTS.labelFees}} </span>
                  <br class="mobile-break">
                  {{entity.saleFee ?  formatCurrency(entity.saleFee) : 'N/A'}}
                </p>
                <p>
                  <span class="bold">{{CONSTANTS.labelHighestOfferPrice}} </span>
                  <br class="mobile-break">
                  {{entity.highestOffer ?  formatCurrency(entity.highestOffer) : 'N/A'}}
                </p>
                <button
                  class="btn btn-link see-details"
                  [attr.aria-label]="CONSTANTS.labelSeeDetails"
                  (click)="seeDetails(i)"
                  >
                  <strong>{{CONSTANTS.labelSeeDetails}}</strong>
                </button>
              </div>
            </div>
          }
        </div>
        <div class="offer-history__footer d-none d-lg-block"></div>
        <div class="offer-history__footer-mobile d-flex flex-column d-lg-none">
        </div>
        <div class="d-flex flex-column flex-lg-row lg-justify-content-start action-buttons">
          <button class="btn btn-primary" (click)="close()" allytmln="closeButton" type="button"
            data-track-elem="button" data-track-name="Close"
            id="purchaseOfferHistoryModal_close_button">
            {{ CONSTANTS.btnClose}}
          </button>
        </div>
      }
      <div class="modal-close-container">
        <button
          class="modal__close"
          [attr.aria-label]="CONSTANTS.btnClose"
          data-track-elem="icon"
          data-track-name="Close"
          data-track-trigger="close"
          (click)="close()">
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  }
</app-modal>
